import { render, staticRenderFns } from "./HistoryPrice.vue?vue&type=template&id=da40e710&scoped=true&"
import script from "./HistoryPrice.vue?vue&type=script&lang=js&"
export * from "./HistoryPrice.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPrice.vue?vue&type=style&index=0&id=da40e710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da40e710",
  null
  
)

export default component.exports